import store from '@/store';
import mixpanel from 'mixpanel-browser';
import moment from 'moment';
const FORMAT_DATE = 'DD-MM-YYYY, HH:mm:ss';
export const track = (event, payload = {}) => {
    mixpanel.track(event, {
        brand: store.getters?.selectedBrand?.id,
        ...payload,
    });
};
export const useMixpanelConfig = (pageViewName) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.id,
    });
};
export const useMixpanelConfigAudience = (pageViewName, id, name) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        audience_id: id,
        audience_name: name,
    });
};
export const useMixpanelConfigLabels = (pageViewName, id, name) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        labels_id: id,
        labels_name: name,
    });
};
export const useMixpanelConfigPersonas = (pageViewName, id, name) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        personas_id: id,
        personas_name: name,
    });
};
export const useMixpanelConfigProductDetail = (pageViewName, id, name) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        product_id: id,
        product_name: name,
    });
};
export const useMixpanelConfigCategorytDetail = (pageViewName, name) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        category_name: name,
    });
};
export const useMixpanelSelectConversionWindow = (pageViewName, lookback) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        number_of_days: lookback,
    });
};
export const useMixpanelSelectContactType = (pageViewName, contactType) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        contact_type: contactType,
    });
};
export const useMixpanelSelectSegment = (pageViewName, segment) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        segment: segment,
    });
};
export const useMixpanelSelectSegmentBy = (pageViewName, id) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        id: id,
    });
};
export const useMixpanelSelectAggregation = (pageViewName, value) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        selected_aggregation: value,
    });
};
export const useMixpanelExportTableIndicators = (pageViewName, aggregation, columns, fileType, filterConversionWindow, filterContactType, filterSegmentId, filterSegmentBy) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        selected_aggregation: aggregation,
        visible_columns: columns,
        startDate: store.getters.dates.startDate,
        endDate: store.getters.dates.endDate,
        filetype: fileType,
        filter_conversion_window: filterConversionWindow,
        filter_contact_type: filterContactType,
        filter_segment_id: filterSegmentBy,
        filter_segment_by: filterSegmentId,
    });
};
export const useMixpanelUpdateColumns = (pageViewName, columns) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        selected_columns: columns,
    });
};
export const useMixpanelSortedColumn = (pageViewName, column, type) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        column: column,
        orderType: type,
    });
};
export const useMixpanelComparableUpdate = (pageViewName, metrics, criteria, comparisonStoresList) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        metrics: metrics,
        criteria: criteria,
        comparisonStoresList: comparisonStoresList,
    });
};
export const useMixpanelDatepicker = (pageViewName, startDate, endDate) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        current: moment(new Date()).format(FORMAT_DATE),
        startDate: moment(startDate).format(FORMAT_DATE),
        endDate: moment(endDate).format(FORMAT_DATE),
    });
};
export const useMixpanelDatepickerPanelLinks = (pageViewName, text, dates) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        text: text,
        current: moment(new Date()).format(FORMAT_DATE),
        startDate: moment(dates['startDate']).format(FORMAT_DATE),
        endDate: moment(dates['endDate']).format(FORMAT_DATE),
    });
};
export const useMixpanelDataInconsistency = (pageViewName) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
    });
};
export const useMixpanelPushCommunications = (pageViewName) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
    });
};
export const useMixpanelTableAction = (pageViewName, column, additionalProps) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.id,
        column,
        ...additionalProps,
    });
};
